<template>
  <div class="card">
    <div class="card-layout-header">
      <div class="card-layout-title">
        <span class="card-title text-primary">
          <slot name="title"/>
        </span>
        <span class="card-subtitle text-primary">
          <slot name="subtitle"/>
        </span>
      </div>
      <div v-if="prompt" class="card-prompt">
        <prompt>{{ prompt }}</prompt>
      </div>
    </div>
    <div class="card-layout-content">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
import Prompt from '@/components/common/Prompt.vue'

export default {
  props: ['prompt'],
  components: {
    Prompt
  }
}
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
  background-color: white;
  border-radius: .3rem;
  // box-shadow: 0px 1px 3px #d2dae0;
  line-height: 1.5;
  &-layout {
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px #F0F4F8 solid;
    }
    &-title {
      width: 100%;
      padding: .5rem .5rem .5rem .5rem;
    }
    &-content {
      width: 100%;
      padding: .5rem .5rem .5rem .5rem;
    }
  }
  &-prompt {
    align-self: flex-start;
    padding: .5rem;
  }
  &-title {
    font-size: .85rem;
  }
  &-subtitle {
    font-size: .75rem;
  }
}
@media screen and (min-width: 30em) and (max-width: 80em) {
  .card {
    &-layout {
      &-title {
        padding: 1rem 1rem 1rem 1rem;
      }
      &-content {
        padding: 1rem 1rem 1rem 1rem;
      }
    }
    &-title {
      font-size: .85rem;
    }
    &-subtitle {
      font-size: .85rem;
    }
  }
}
@media screen and (min-width: 80em) {
  .card {
    &-layout {
      &-title {
        padding: 1rem 1rem 1rem 1rem;
      }
      &-content {
        padding: 1rem 1rem 1rem 1rem;
      }
    }
    &-title {
      font-size: .85rem;
    }
    &-subtitle {
      font-size: .85rem;
    }
  }
}
</style>
